export const HomeRoutes = {
    Base: '/',
    Booking: 'booking',
    BookingId: ':id',
    BookingEditGuest: 'edit-guest',
};
